exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3NeZxSa86eeIGCSkXPKTLO{height:16px}._13JsLKHkwmUjIt57kJPaqb{cursor:pointer;white-space:nowrap;text-decoration:none}._3fxv3EWU3ZNdThLp-r1aNP{font-weight:600}._2-jDBHdx2ZMrzRFYtEMOED:after{content:\" \"}", ""]);
// Exports
exports.locals = {
	"recipientRowIcon": "_3NeZxSa86eeIGCSkXPKTLO",
	"link": "_13JsLKHkwmUjIt57kJPaqb",
	"recipientName": "_3fxv3EWU3ZNdThLp-r1aNP",
	"blankSpaceAfter": "_2-jDBHdx2ZMrzRFYtEMOED"
};